import { withOptionsEndpoint, withStoreEndpoint } from "@dgs/core";
import { LocationOptionResource, LocationSaveRequest } from "../types/location";

const baseKey = ["locations"];
const quickFilterKey = [...baseKey, "quick-filter"];

export const locationService = {
	...withOptionsEndpoint<LocationOptionResource>(baseKey),
	...withStoreEndpoint<LocationSaveRequest>(baseKey),
	quickFilterKey,
};
